import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA2ywTmlmjN1Qi1ltUqSupn7FV7jJvZKzE",
  authDomain: "trading-wealth-crm.firebaseapp.com",
  projectId: "trading-wealth-crm",
  storageBucket: "trading-wealth-crm.firebasestorage.app",
  messagingSenderId: "313550223228",
  appId: "1:313550223228:web:b38b8ce2b87a968e3c96f9",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;